import * as React from 'react';
import { EStarTheme } from '../../types/star';
import { getUnits } from '../../utils';
import { Star } from '../Star';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function Stars(_ref) {
  var value = _ref.value,
    size = _ref.size;
  var units = React.useMemo(function () {
    return getUnits(5, value);
  }, [value]);
  return /*#__PURE__*/_jsx("ul", {
    className: styles['container'],
    children: units.map(function (unit, index) {
      return /*#__PURE__*/_jsx("li", {
        className: styles['element'],
        children: /*#__PURE__*/_jsx(Star, {
          value: unit,
          theme: EStarTheme.Fillable,
          size: size
        })
      }, index);
    })
  });
}